import React, {
  createContext,
  useState,
  FunctionComponent,
  useContext,
} from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Location } from 'history';

import { Type as TopMetroView } from 'components/TopMetros/TopMetros.helpers';
import { GET_PROFILE } from 'components/UserMgmt/UserMgmt.queries';
import { Profile } from 'components/UserMgmt/UserMgmt.helpers';
import { getHashFromProps } from './MerchantOverview.helper';

type Props = { children: React.ReactNode; location: Location };
export type KeyMetricView = TopMetroView;

export type UseMerchantOverview = {
  keyMetricView: KeyMetricView;
  topMetroView: TopMetroView;
  userProfile: Profile;
  setState: Function;
};

type MerchantOverview = {
  keyMetricView: KeyMetricView;
};

type State = [MerchantOverview, Function];

const MerchantOverviewContext = createContext<State>([
  { keyMetricView: 'Sales' },
  () => {},
]);

const MerchantOverviewProvider: FunctionComponent<Props> = ({
  location,
  ...props
}) => {
  const [state, setState] = useState<MerchantOverview>({
    keyMetricView: getHashFromProps(location),
  });

  const value = React.useMemo(() => [state, setState], [state]);

  return <MerchantOverviewContext.Provider value={value as State} {...props} />;
};

const useMerchantOverview = (): UseMerchantOverview => {
  const { data } = useQuery(GET_PROFILE);
  const [state, setState] = useContext<State>(MerchantOverviewContext);
  const { keyMetricView } = state;

  return {
    setState,
    keyMetricView,
    userProfile: data.userProfile,
    topMetroView: keyMetricView,
  };
};

export { MerchantOverviewProvider, useMerchantOverview };
